module["exports"] = [
  "com",
  "net",
  "info",
  "vn",
  "com.vn"
];
